/** Enum editor — a <select> over the schema's inline options. */
import type { ProposalFieldEditorProps } from "../ProposalEditor.js";
import { controlStyle, fieldDomId } from "../ProposalEditor.js";

export function EnumField({ field, value, onChange, idPrefix }: ProposalFieldEditorProps) {
  const options = field.options ?? [];
  const current = value == null ? "" : String(value);
  return (
    <select
      id={fieldDomId(idPrefix, field.key)}
      aria-label={field.label}
      style={controlStyle}
      value={current}
      onChange={(e) => onChange(e.target.value)}
    >
      {!options.some((o) => o.value === current) && (
        <option value="" disabled>
          Select…
        </option>
      )}
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  );
}
